import {
  GNSSAddStation,
  GNSSEditStations,
  GNSSLocations,
  GNSSOverview,
  GNSSInterferenceReport,
  GNSSPerformanceReport,
  GNSSSpectrum,
  Login,
  PageNotFound,
  RegisterUser,
  RegisterOwner,
  Unauthorized,
  UsersManagement,
  ChangePassword,
  Profile,
  NetworksManagement,
  SelectTenant,
  ForgotPassword
} from "pages";



const runtimeConfig = window.RUNTIME_CONFIG || {};

const sidebarConfig = {
  sections: [
    {
      title: "OVERVIEW",
      subsections: [
        {
          title: "Dashboard",
          route: "/overview/dashboard",
          icon: "overview-icon",
          roles: ["Administrator", "User", "Tenant Owner", "Tenant User"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_DASHBOARD,
          component: () => <GNSSOverview />,
        },
        {
          title: "Locations",
          route: "/overview/locations",
          icon: "location-pin-icon",
          roles: ["Administrator", "User", "Tenant Owner", "Tenant User"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_LOCATIONS,
          component: () => <GNSSLocations />,
        },
      ],
    },
    {
      title: "GNSS STATIONS",
      subsections: [
        {
          title: "GNSS Spectrum",
          route: "/gnss/spectrum",
          icon: "spectrum-icon",
          roles: ["Administrator", "User", "Tenant Owner", "Tenant User"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_REALTIME_GNSS,
          component: () => <GNSSSpectrum />,
        },
        {
          title: "GNSS Interferences",
          route: "/gnss/interference-report",
          icon: "interference-icon",
          roles: ["Administrator", "User", "Tenant Owner", "Tenant User"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_INTERFERENCE_GNSS,
          component: () => <GNSSInterferenceReport />,
        },
        {
          title: "GNSS Performance",
          route: "/gnss/performance-report",
          icon: "report-icon",
          roles: ["Administrator", "User", "Tenant Owner", "Tenant User"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_PERFORMANCE_GNSS,
          component: () => <GNSSPerformanceReport />,
        },
        {
          title: "Add GNSS Stations",
          route: "/gnss/add",
          icon: "add-icon",
          roles: ["Administrator","Tenant Owner"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_ADD_GNSS,
          component: () => <GNSSAddStation />,
        },
        {
          title: "Edit GNSS Stations",
          route: "/gnss/edit",
          icon: "edit-icon",
          roles: ["Administrator","Tenant Owner"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_EDIT_GNSS,
          component: () => <GNSSEditStations />,
        },
      ],
    },

    {
      title: "SETTINGS",
      subsections: [
        {
          title: "Profile",
          route: "/settings/profile",
          icon: "avatar-icon",
          roles: ["Administrator", "User", "Tenant Owner", "Tenant User"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_SETTINGS,
          component: () => <Profile />,
        },
        {
          title: "Networks",
          route: "/settings/networks",
          icon: "network-icon",
          roles: ["Administrator", "User", "Tenant Owner", "Tenant User"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_SETTINGS,
          component: () => <NetworksManagement />,
        },
        {
          title: "Users Management",
          route: "/settings/users-management",
          icon: "users-management-icon",
          roles: ["Administrator","Tenant Owner"],
          isEnabled: runtimeConfig.ROUTES.ENABLE_SETTINGS,
          component: () => <UsersManagement />,
        },
        
      ],
    },
  ],
};

const publicRoutes = [
  {
    route: "/login",
    component: () => <Login />,
  },
  {
    route: "/select-tenant",
    component: () => <SelectTenant />,
  },
  {
    route: "/register/user",
    component: () => <RegisterUser />,
  },
    {
    route: "/register/owner",
    component: () => <RegisterOwner />,
  },
  {
    route: "/unauthorized",
    component: () => <Unauthorized />,
  },
  {
    route: "/forgotpassword",
    component: () => <ForgotPassword/>
  },
    {
    route: "/changepassword",
    component: () => <ChangePassword/>
  },
  {
    route: "*",
    component: () => <PageNotFound />,
  },
];

export { publicRoutes, sidebarConfig };

